import React, {Component} from 'react';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';

export default class ModalMultiplaEscolha extends Component {
	render() {
        const mensagens = this.props.mensagem ? this.props.mensagem.split("<br />") : []
		return (
            <ModalContainer zIndex={100} className="modal-layer" >
                <ModalDialog className="nosso-modal modal-conteudo">
                    <div className="modal-escolhas">
                        { mensagens && mensagens.map((m, x) => 
                            <h2 key={x}>{m}</h2>
                        ) }
                        <div className="botoes">
                            {this.props.children}
                        </div>
                    </div>
                </ModalDialog>
            </ModalContainer>
        )
	}
}   



// WEBPACK FOOTER //
// ./src/modules/comum/components/ModalMultiplaEscolha.js